import { Component, OnInit, Input } from '@angular/core';
import { Book } from '../../../../../../shared/models/book';
import { EditorService } from '../../../../../bookeditoption/editor.service';
@Component({
  selector: 'app-imageGallerymedia',
  templateUrl: './imageGallerymedia.component.html',
  styleUrls: ['./imageGallerymedia.component.css']
})
export class ImageGallerymediaComponent implements OnInit {
  @Input() data: any;
  public bookObj: Book;
  ImageDataUrl;
  constructor(private editorService: EditorService) { }

  ngOnInit() {
    this.bookObj = this.data.popupProps.curComp.bookObj;
    let cardData = this.editorService.textInlineData;
    if (cardData && cardData.type == "IMAGE") {
      this.initializeData(cardData);
    }
  }
  initializeData(data) {
    if (data && data.imageSrc) {
      data.url = data.imageSrc;
      this.ImageDataUrl = data;
    }
  }
  onChangeGalleryimage(img) {
    let layer = this.editorService.getIframeReference();
    layer.updateImageSrc(img.url, img.type);
  }
}



// WEBPACK FOOTER //
// ./src/app/bookShared/bookeditoption/bookEditOptionPopups/media/image/imageGallerymedia/imageGallerymedia.component.ts